interface Config {
  API_BASE_URL: string;
  CMS_BASE_URL: string;
  GA_ID?: string;
  CLARITY_ID?: string;
  CHAT_WIDGET_URL?: string;
}

const config: Config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://localhost:8443',

  // CMS Configuration
  CMS_BASE_URL:
    process.env.REACT_APP_CMS_BASE_URL || 'https://cms.akygacomponents.com',

  // Third-party tracking/chat, all optional - unset means the feature stays
  // off (see CookieConsentContext, which also requires consent to load any
  // of these even when configured).
  GA_ID: process.env.REACT_APP_GA_ID,
  CLARITY_ID: process.env.REACT_APP_CLARITY_ID,
  CHAT_WIDGET_URL: process.env.REACT_APP_CHAT_WIDGET_URL,
};

export default config;
